<script>
	export default {
		data() {
			return {
				colors: {
					cold: '#a4005c',
					hot: '#00a354',
				},
				hovered: false,
				// selected: false,
				shape: null,
			}
		},

		props: {
			minSearches: 0,
			maxSearches: 0,
			google: {
				type: Object,
				required: true
			},
			map: {
				type: Object,
				required: true
			},
			outward: {
				type: Object,
				required: true
			},
			selected: {
				type: Boolean,
				required: true,
			},
		},

		computed: {
			options() {
				return {
					strokeColor: this.color(),
					strokeWeight: this.strokeWeight(),
					fillColor: this.color(),
					fillOpacity: this.fillOpacity(),
					zIndex: this.zIndex(),
				}
			}
		},

		methods: {
			zIndex() {
				if (this.hovered || this.selected) {
					return 3
				}

				return this.outward.postcode_searches.length ? 2 : 1
			},
			color() {
				if (this.hovered || this.selected) {
					return '#000000'
				}

				if (!this.outward.postcode_searches.length) {
					return this.colors.cold
				}

				return this.colors.hot
			},
			fillOpacity() {
				if (this.hovered) {
					return 0
				}

				if (this.outward.postcode_searches.length) {
					return this.fillOpacityForUnlinked()
				}

				return .2
			},
			fillOpacityForUnlinked() {
				var opacity = 0
				var minOpacity = .2
				var maxOpacity = .8

				if (!this.outward.postcode_searches.length) {
					return opacity
				}

				var position = this.outward.postcode_searches.length / this.maxSearches // 1 / 1 = 1, 1/2=.5
				var opacityRange = maxOpacity - minOpacity // .8-.2=.6
				var opacityPosition = opacityRange * position // .6*.5=.3
				opacity = minOpacity + opacityPosition

				return opacity
			},
			strokeWeight() {
				if (this.selected || this.hovered) {
					return 4
				}
				return 2
			},
			setOptions() {
				this.shape.setOptions(this.options)
			},
			show() {
				if (this.shape) {
					this.shape.setMap(null)
					this.shape = null
				}

				this.shape = new this.google.maps.Polygon({
					paths: this.outward.coords,
					map: this.map,
				})

				this.setOptions()

				var self = this

				self.shape.addListener('click', function(event) {
					return !self.selected
						? self.$emit('outward-selected', self.outward)
						: self.$emit('outward-deselected', self.outward)
				})

				self.shape.addListener('mouseover', function(event) {
					self.hovered = true
					self.$emit('outward-mousedover', self.outward)
				})

				self.shape.addListener('mouseout', function(event) {
					self.hovered = false
					self.$emit('outward-mousedout', self.outward)
				})
			},
			hide() {
				console.log('hide')
				this.shape.setMap(null)
				this.shape = null
			},
		},

		created() {
			this.show()
		},

		watch: {
			options: {
				deep: true,
				handler: 'setOptions',
			},
			outward: {
				deep: true,
				handler: 'show',
			},
			minSearches: 'setOptions',
			maxSearches: 'setOptions',
			hovered: 'setOptions',
			selected: 'setOptions',
		},

		beforeDestroy() {
			this.hide()
		},

		render() {}
	}
</script>
